import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import PhoneLink from 'components/common/PhoneLink'
import Link from 'components/common/Link/Link'
import { ServiceIcon } from 'components/common/ServiceIcon'
import { formatPrice } from 'helpers/utils'
import { Block, Cell, Text, CallStore } from '../../../Common.styles'
import { CALL_STORE_FOR_PRICE_FIRST_TEXT } from 'constant'

const ServiceBlock = ({
  className,
  service: {
    iconName,
    name,
    qty,
    totalPrice
  },
  storePhoneNumber = '',
  formattedStorePhoneNumber = '',
  showStoreLocatorModalInAppointmentMode,
  myStore,
  handleTAOSDateTimeUpdate,
  ...props
}) =>
  <Wrapper data-at-appointment-service className={ className } { ...props }>
    <Media.Desktop>
      <ImageWrapper data-at-appointment-service-img>
        <ServiceIcon iconName={ iconName } full />
      </ImageWrapper>
    </Media.Desktop>
    <Title data-at-appointment-service-title>
      { name }
    </Title>
    <Block data-at-appointment-service-qty>
      <Text margin>Qty:</Text>
      <Text>{ qty }</Text>
    </Block>
    {
      totalPrice ?
        <Cell>
          <Mobile><Text margin>Total Price:</Text></Mobile>
          <Text data-at-appointment-service-price bold>{ formatPrice(totalPrice) }</Text>
        </Cell> :
        <Fragment>
          {
            !myStore ?
              <Cell data-at-appointment-service-price>
                <StoreLink prevent to="/" bolder handler={ () => showStoreLocatorModalInAppointmentMode(handleTAOSDateTimeUpdate) }>
                  Find Store for Price
                </StoreLink>
              </Cell> :
              <Cell data-at-appointment-service-price>
                <CallStore>
                  { CALL_STORE_FOR_PRICE_FIRST_TEXT }
                  <Media.Mobile>
                    <StyledPhoneLink number={ storePhoneNumber } />
                  </Media.Mobile>
                  <Media.Desktop>
                    <CallStore>{ formattedStorePhoneNumber }</CallStore>
                  </Media.Desktop>
                </CallStore>
              </Cell>
          }
        </Fragment>
    }
  </Wrapper>

ServiceBlock.propTypes = {
  className: PropTypes.string,
  formattedStorePhoneNumber: PropTypes.string,
  handleTAOSDateTimeUpdate: PropTypes.func,
  myStore: PropTypes.shape(),
  service: PropTypes.shape({
    iconName: PropTypes.string,
    name: PropTypes.string,
    qty: PropTypes.number,
    totalPrice: PropTypes.number
  }),
  showStoreLocatorModalInAppointmentMode: PropTypes.func,
  storePhoneNumber: PropTypes.string
}

export default ServiceBlock

const Wrapper = styled.div`
  & + & {
    border-top: 1px solid ${Theme.colors.light_grey};
  }

  ${Mixin.responsive('padding', '30px 0', '20px 0')}
  ${Mixin.clearFix()}
`

const ImageWrapper = styled.div`
  display: inline-block;
  text-align: center;
  background-color: ${Theme.colors.white};
  padding: 10px;
  ${Mixin.responsive('width', '144px', '60px')}
  ${Mixin.responsive('height', '144px', '60px')}
`

const Title = styled.div`
  color: ${Theme.colors.sub_grey};
  ${Media.desktop`
    display: inline-block;
    width: 276px;
    padding: 0 24px;
    margin-top: 27px;
    vertical-align: top;
  `}
  ${Mixin.font.GothamMedium(18, 500, 24)}
`

const StoreLink = styled(Link)`
  ${Mixin.responsive('line-height', '22px', '19px')}
`

const StyledPhoneLink = styled(PhoneLink)`
  display: block;
  font-weight: 600;
  line-height: 22px;
`

const Mobile = styled.span`
  ${Mixin.mobileOnly()}
`
